import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { LANGUAGE_CONST } from "../../../constant/LanguageConst";

const LanguageMenu = () => {
  const intl = useIntl();

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const popupRef = useRef<HTMLDivElement>(null);

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        setIsPopupOpen(false);
      }
    };

    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen]);

  return (
    <>
      <div className="relative">
        <button
          onClick={(e) => {
            e.stopPropagation();
            togglePopup();
          }}
          className="flex items-center justify-center w-10 h-10 text-lg font-bold"
        >
          {intl.locale.toUpperCase()}
        </button>

        {/* Popup */}
        {isPopupOpen && (
          <div
            ref={popupRef}
            className="absolute right-0 z-10 w-32 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg"
          >
            {Object.values(LANGUAGE_CONST).map((language) => (
              <button
                onClick={() => {
                  window.dispatchEvent(
                    new CustomEvent("languageChange", {
                      detail: {
                        language,
                      },
                    })
                  );
                  togglePopup();
                }}
                key={language}
                className="flex items-center w-full gap-2 px-4 py-2 text-left text-gray-800 hover:bg-gray-100"
              >
                <div className="text-lg font-bold">
                  {language.toUpperCase()}
                </div>
                <div>{intl.formatMessage({ id: language })}</div>
              </button>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default LanguageMenu;
